import CancelIcon from "@mui/icons-material/Cancel";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ErrorWarningTabs } from "./ErrorWarningTabs";
import { ErrorTab } from "./ErrorTab";
import CircularProgress from "@mui/material/CircularProgress";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useDashboardStore } from "./store/dashboardStore";

export const TotalCamerasTable = () => {
  const { dashboardTotal } = useDashboardStore();

  const theme = createTheme({
    palette: {
      primary: {
        main: "#001943",
      },
      secondary: {
        main: "#F57C00",
      },
      success: {
        main: "#2E7D32",
      },
      error: {
        main: "#F44336",
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div className="w-full min-w-0 bg-white">
        <div className="flex flex-wrap items-stretch gap-x-6 gap-y-4 px-6 py-5 sm:flex-nowrap">
          <div className="shrink-0 border-r-4 border-[#BDBDBD] pr-8">
            {Number(dashboardTotal.total) >= 0 ? (
              <p className="text-actuate-blue font-mulish text-[26px] font-bold">
                {dashboardTotal.total}
              </p>
            ) : (
              <CircularProgress color="primary" size={35} />
            )}
            <p className="text-actuate-blue font-mulish text-[16px] font-bold">
              Total Cameras
            </p>
          </div>
          <div className="flex min-w-0 flex-1 items-center justify-around gap-4">
            <div className="flex flex-col items-center">
              {Number(dashboardTotal.error) >= 0 ? (
                <p className="text-[#F44336] font-mulish text-[16px] font-bold">
                  {dashboardTotal.error}
                </p>
              ) : (
                <CircularProgress color="error" size={25} />
              )}
              <p className="text-[#F44336] font-mulish text-[16px]">Error</p>
              <CancelIcon sx={{ color: "#F44336" }} />
            </div>
            <div className="flex flex-col items-center">
              {Number(dashboardTotal.warning) >= 0 ? (
                <p className="text-[#F57C00] font-mulish text-[16px] font-bold">
                  {dashboardTotal.warning}
                </p>
              ) : (
                <CircularProgress color="secondary" size={25} />
              )}
              <p className="text-[#F57C00] font-mulish text-[16px]">Warning</p>
              <ErrorIcon sx={{ color: "#F57C00" }} />
            </div>
            <div className="flex flex-col items-center">
              {Number(dashboardTotal.healthy) >= 0 ? (
                <p className="text-[#2E7D32] font-mulish text-[16px] font-bold">
                  {dashboardTotal.healthy}
                </p>
              ) : (
                <CircularProgress color="success" size={25} />
              )}
              <p className="text-[#2E7D32] font-mulish text-[16px]">Healthy</p>
              <CheckCircleIcon sx={{ color: "#2E7D32" }} />
            </div>
          </div>
        </div>
        <div className="px-6">
          <ErrorWarningTabs />
        </div>
        <div className="pt-4">
          <ErrorTab />
        </div>
      </div>
    </ThemeProvider>
  );
};
